"use client";
import React, {useEffect, useState} from "react";
import {Banner} from "../components";
import {FontIcon, GuidePage} from "@/app/_components";
import type {GuidePageProps} from "@/app/_components/GuidePage/GuidePage";
import styles from "./page.module.css";
import {Step1, Step2, Step3, Step4, Step5} from "@/app/_components/GuidePage/NewComer";
import {useUser} from "@/app/context/UserContext";
import {homeData} from "./homeData";
import GameItem from "@/app/(pages)/components/GameItem/GameItem";
import Load from "@/app/_components/Load/Load";
import GuideMgr, {GuideIDType} from "@/Core/GuideMgr";

export default function HomePage() {

    const [hotGameList, setHotGameList] = useState<any[]>([]);
    const [topGameList, setTopGameList] = useState<any[]>([]);

    const [guideState,setGuideState] = useState<string>("0");
    const [guideOpen, setGuideOpen] = useState<boolean>();
    const [guideSteps, setGuideSteps] = useState<GuidePageProps['steps']>([]);

    const user = useUser();
    useEffect(() => {
        if (user.guideID === GuideIDType.guide_1001 && !guideOpen) {
            setGuideOpen(true);
            const steps: GuidePageProps['steps'] = [
                {
                    content: <Step1 currIndex={0} target={() => document.querySelector('#guideStep1_2')}/>,
                },
                {
                    content: <Step2 currIndex={1} target={() => document.querySelector('#guideStep1_2')}/>,
                },
                {
                    content: <Step3 currIndex={2} target={() => document.querySelector('#guideStep3')}/>,
                },
                {
                    content: <Step4 currIndex={3} target={() => document.querySelector('#guideStep4')}/>,
                },
                {
                    content: <Step5 currIndex={4} target={() => document.querySelector('#guideStep5')}/>,
                },
            ]
            setGuideSteps(steps);
        }
    }, [user.guideID]);

    const onGuideEnd = () => {
        GuideMgr.setGuideId(GuideIDType.guide_end);
        setGuideOpen(false);
    }

    useEffect(() => {
        let list = homeData;
        let hotList = [];
        let topList = [];
        for (let i = 0; i < list.length; i++) {
            const item = list[i];
            switch (item.type) {
                case 1:
                    hotList.push(item);
                    break;
                case 2:
                    topList.push(item);
                    break;
                default:
                    break;
            }
        }
        setHotGameList(hotList);
        setTopGameList(topList);
    }, [homeData])


    return (
        <div className={styles.page}>
            <Banner/>
            {/*<HomeBanner/>*/}
            <section className={styles.game_list_wrapper}>
                <p className={styles.game_list_title}>
                    <FontIcon icon={'s-fire item-color'}></FontIcon>
                    <span style={{margin: '.25rem'}}>Hot Games</span>
                    <FontIcon icon={'s-fire item-color'}></FontIcon>
                </p>
                {
                    hotGameList && hotGameList.length > 0 ? (
                        <div className={styles.game_list_grid}>
                            {hotGameList.map((item, key) => (
                                <GameItem data={item} key={key}/>
                            ))}
                        </div>
                    ) : <Load/>
                }
            </section>

            <section className={styles.game_list_wrapper}>
                <p className={styles.game_list_title}>
                    <FontIcon icon={'s-medal item-color'}></FontIcon>
                    <span style={{margin: '.25rem'}}>Top Games</span>
                    <FontIcon icon={'s-medal item-color'}></FontIcon>
                </p>
                {
                    topGameList && topGameList.length > 0 ? (
                        <div className={styles.game_list_grid}>
                            {topGameList.map((item, key) => (
                                <GameItem data={item} key={key}/>
                            ))}
                        </div>
                    ) : <Load/>
                }
            </section>

            <GuidePage open={guideOpen} steps={guideSteps} onGuideEnd={onGuideEnd}/>


            <div className={'header_panel'}></div>
        </div>
    )
}
